import { Injectable, OnInit } from '@angular/core';
import { ToastrService, DefaultGlobalConfig, IndividualConfig } from 'ngx-toastr';
import { TranslateResourceDefinitionPipe } from '../shared/pipes/translateResourceDefinition.pipe';
import { SharingDataService } from './sharing-data.service';


@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {

  constructor(private toastrService: ToastrService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
    private shareData: SharingDataService) {
    this.configureToastr();
    this.shareData.currentResourceDefinition.subscribe((data) => { this.resourceDefinition = data; })
  }

  resourceDefinition;

  showSuccess(message?: string, title?: string, config?: Partial<IndividualConfig>) {
    this.toastrService.success(message, title ? title : this.defaultSuccessTitle, config);
  }

  showError(message?: string, title?: string, config?: Partial<IndividualConfig>) {
    this.toastrService.error(message, title ? title : this.defaultErrorTitle, config);
  }

  showInfo(message?: string, title?: string, config?: Partial<IndividualConfig>) {
    this.toastrService.info(message, title, config);
  }


  configureToastr() {
    this.toastrService.toastrConfig.autoDismiss = true;
    this.toastrService.toastrConfig.closeButton = true;
    this.toastrService.toastrConfig.newestOnTop = true;
    this.toastrService.toastrConfig.tapToDismiss = true;
  }

  private get defaultErrorTitle() {
    return this.translateResourceDefinition.transform('FAIL', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common");
  }

  private get defaultSuccessTitle() {
    return this.translateResourceDefinition.transform('SUCCESS', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common")
  }


}
